<script lang="ts" setup>
interface Props {
  type?: 'connection' | 'http' | 'general';
  title?: string;
  message?: string;
  showRetry?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  type: 'general',
  showRetry: true,
});

const emit = defineEmits<{
  retry: [];
}>();

const defaultTitles = {
  connection: 'Connection Error',
  http: 'Server Error',
  general: 'Error',
};

const defaultMessages = {
  connection: 'Unable to connect to the server. Please check your connection and try again.',
  http: 'The server encountered an error. Please try again later.',
  general: 'An error occurred. Please try again.',
};

const defaultIcons = {
  connection: 'bi-wifi-off',
  http: 'bi-exclamation-triangle',
  general: 'bi-exclamation-circle',
};

const displayTitle = props.title || defaultTitles[props.type];
const displayMessage = props.message || defaultMessages[props.type];
const displayIcon = defaultIcons[props.type];
</script>

<template>
  <div class="error-state text-center py-5">
    <i class="error-icon" :class="[displayIcon, 'fs-1', 'mb-3', 'd-block']"></i>
    <h3 class="error-title mb-2">{{ displayTitle }}</h3>
    <p class="error-message text-muted mb-4">{{ displayMessage }}</p>
    <button
      v-if="showRetry"
      class="bb-btn-primary-cta"
      @click="emit('retry')"
    >
      <i class="bi bi-arrow-clockwise me-2"></i>Try Again
    </button>
  </div>
</template>

<style lang="scss" scoped>
.error-state {
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.error-icon {
  color: var(--bs-danger);
  opacity: 0.6;
}

.error-title {
  color: var(--bs-body-color);
}

.error-message {
  max-width: 500px;
}
</style>
